<template>
      <div class="grids">
					<div class="progressbar-heading grids-heading">
						<h2>Enter you email to change password</h2>
					</div>
					<div class="panel panel-widget forms-panel">
						<div class="forms">
							<div class="form-grids widget-shadow" data-example-id="basic-forms"> 
								<div class="form-title">
									<h4>Password Change :</h4>
								</div>
								<div class="form-body">
									<form v-on:submit.prevent="handleSubmit()"> 
                                    <div class="form-group"> 
                                    <label for="exampleInputEmail1">Email address</label> 
                                    <input type="email" class="form-control" id="exampleInputEmail1" v-model="email" placeholder="Email">
                                     </div> 
                                    
                                        
                                          <button type="submit" class="btn btn-default">Submit</button>
                                           </form> 
								</div>
							</div>
						</div>
					</div>
					
					
              
                  
					
				</div>
</template>

<script>
import axios from "axios";
export default {
  name: 'passwordReset',
  props: {
   
},
data()
{
	return{
		tokenPresence: false,
		email: null
	}
},
mounted()
{  let accessToken = localStorage.getItem("token");
       if(accessToken !== "noToken")
        {
         if(accessToken !== null)
        {
           // alert(accessToken);
            this.tokenPresence = true;
            
        }
            
        }
       
       

        if(accessToken !== null)
        {
          if(accessToken !== "noToken")
        {
           // alert(accessToken);
            this.tokenPresence = true;
            
        }
            
        }
        

        if((accessToken != "noToken") && (accessToken !== null) && (this.tokenPresence == true))
        {
            this.$router.push("/timeawards/userDashboard");
        }

},
methods:
{
	handleSubmit: async function()
	{
		try{
		let Response = await axios({
       method: "post",
	   url: 'https://time-person-mofe.herokuapp.com/api/forgotPassword',
	   data:
	   {
		   email: this.email
	   }
     });

    if(Response.data.status == "success")
    {
		alert(Response.data.message);
        //this.$router.push("/userDashboard");
    }
    else{
       alert(Response.data.message);
     
    	}
	}
	catch(error)
	{
		alert(error);

	}
	}
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
